export default "__VITE_ASSET__D9vOUi3D__"